exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ulBbHiLD4uV9S3{position:absolute;height:64px;width:64px;transition:transform 85ms ease-in,opacity 85ms ease-in;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sR3Nr-iFZ1PoLq{height:64px;width:64px;color:transparent;border:0}", ""]);

// exports
exports.locals = {
	"sticker": "ulBbHiLD4uV9S3",
	"stickerImage": "sR3Nr-iFZ1PoLq"
};